import React from 'react';
import { wait } from 'utils/common';
import PropTypes from 'prop-types';
import { loadCustomScrollbar } from 'utils/moduleLoaders';
// eslint-disable-next-line no-unused-vars
import s from './ScrollBar.scss';

class ScrollBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.myRef = React.createRef();
  }
  async componentDidMount() {
    const { delay = 300 } = this.props;
    await wait(delay);
    await this.attachScrollBar();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.updateScroll !== this.props.updateScroll &&
      typeof this.scrollBarObject.destroy === 'function'
    ) {
      this.scrollBarObject.destroy();
      this.attachScrollBar();
    }
  }
  componentWillUnmount() {
    if (
      this.scrollBarObject &&
      typeof this.scrollBarObject.destroy === 'function'
    ) {
      this.scrollBarObject.destroy();
    }
  }
  async attachScrollBar() {
    const { default: PerfectScrollbar } = await loadCustomScrollbar();
    if (this.props.children && this.myRef.current instanceof HTMLElement) {
      const scrollBarObject = new PerfectScrollbar(this.myRef.current, {
        suppressScrollX: true,
        // wheelSpeed: 0.3,
        wheelPropagation: false,
        swipeEasing: true,
        passive: true,
      });
      this.scrollBarObject = scrollBarObject;
    }
  }
  render() {
    const { tagElement: MyComponent = 'div', className } = this.props;
    return (
      <MyComponent ref={this.myRef} className={className}>
        {this.props.children}
      </MyComponent>
    );
  }
}
ScrollBar.propTypes = {
  children: PropTypes.element.isRequired,
  tagElement: PropTypes.string,
  className: PropTypes.string,
  updateScroll: PropTypes.bool,
};
ScrollBar.defaultProps = {
  tagElement: 'div',
  className: undefined,
  updateScroll: false,
};

export default ScrollBar;
